
/**
* 用工中心 导出列表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/task/registrationDtl',
          query: {
            id: this.$route.query.id,
          },
        }"
        >报名详情</el-breadcrumb-item
      >
      <el-breadcrumb-item>导出记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column prop="typeDesc" label="导出类型"> </el-table-column>
      <el-table-column prop="statusDesc" label="导出进度"> </el-table-column>
      <el-table-column prop="createdAtStr" label="导出时间"> </el-table-column>
      <el-table-column fixed="right" align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 2"
            size="small"
            type="primary"
            plain
            @click="download(scope.row.downloadUrl)"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
  </div>
</template>

<script>
import { getRegistrationExportList } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileList: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      upload_dialog: {
        title: "上传结算单",
        visible: false,
      },
      title: "添加",
      editForm: {
        date: [],
        batchName: "",
        taskId: "",
        distributionChannel: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
      },

      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  methods: {
    download(url) {
      window.open(url);
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      getRegistrationExportList(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/task/registrationExportList.vue